import { render, staticRenderFns } from "./sendbackDialog.vue?vue&type=template&id=359e4686&scoped=true"
import script from "./sendbackDialog.vue?vue&type=script&lang=js"
export * from "./sendbackDialog.vue?vue&type=script&lang=js"
import style0 from "./sendbackDialog.vue?vue&type=style&index=0&id=359e4686&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e4686",
  null
  
)

export default component.exports